/* eslint-disable */
export default [
  {
    path: '/message-center',
    name: 'MessageCenter',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: 'message-manage/list',
        name: 'MessageCenterMessageManageList',
        component: () => import('@/views/message-center/message-manage/list.vue'),
        meta: {
          title: '消息管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'message-manage/detail/:messageId',
        name: 'MessageCenterMessageManageDetail',
        component: () => import('@/views/message-center/message-manage/detail.vue'),
        meta: {
          title: '消息管理详情',
          noCache: false,
          auth: true,
          activeMenu: 'MessageCenterMessageManageList',
        },
      },
      {
        path: 'config-manage/list',
        name: 'MessageCenterConfigManageList',
        component: () => import('@/views/message-center/config-manage/list.vue'),
        meta: {
          title: '消息配置管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'config-manage/detail/:configId',
        name: 'MessageCenterConfigManageDetail',
        component: () => import('@/views/message-center/config-manage/detail.vue'),
        meta: {
          title: '消息配置详情',
          noCache: false,
          auth: true,
          activeMenu: 'MessageCenterConfigManageList',
        },
      },
      {
        path: 'log-manage/list',
        name: 'MessageCenterLogManageList',
        component: () => import('@/views/message-center/log-manage/list.vue'),
        meta: {
          title: '消息日志管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'log-manage/detail/:logId',
        name: 'MessageCenterLogManageDetail',
        component: () => import('@/views/message-center/log-manage/detail.vue'),
        meta: {
          title: '消息日志详情',
          noCache: false,
          auth: true,
          activeMenu: 'MessageCenterLogManageList',
        },
      },
      {
        path: 'alarm-message-statistic/list',
        name: 'MessageCenterAlarmMessageStatisticList',
        component: () => import('@/views/message-center/alarm-message-statistic/list.vue'),
        meta: {
          title: '告警消息统计',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
